// extracted by mini-css-extract-plugin
module.exports = {"team-slide-wrap":"_1LlAu"};